<template>

    <v-card :color="boxColor"
            @click="localeClicked"
            :class="activeClass"
            :width="width"
            :elevation="elevation"
            @mouseover="mouseover"
            @mouseleave="mouseleave"
    >
        <v-container fluid>
            <v-row dense>

                <v-col cols="4">
                    <v-img max-width="75" :src="cdnBaseUrl(locale.image)"/>
                </v-col>

                <v-col cols="8">
                    <div>
                        {{ locale.country }}
                    </div>
                    <div>
                        {{ locale.language }}
                    </div>
                    <v-container fluid class="pa-0">
                        <v-row no-gutters>

                            <!-- LOCALE CODE -->
                            <v-col cols="6">
                                <v-tooltip top color="primary">
                                    <template v-slot:activator="{ on }">
                                        <v-chip v-on="on" class="mt-1" color="grey" small outlined label>
                                            {{ locale.code }}
                                        </v-chip>
                                    </template>
                                    <span>Locale Code</span>
                                </v-tooltip>
                            </v-col>

                            <!-- LOCALE ID -->
                            <v-col cols="5" class="text-right">
                                <v-tooltip top color="primary">
                                    <template v-slot:activator="{ on }">
                                        <v-chip v-on="on" class="mt-1" color="grey darken-2" small>
                                            {{locale.id}}
                                        </v-chip>
                                    </template>
                                    <span>Locale ID</span>
                                </v-tooltip>
                            </v-col>

                            <!-- SELECTOR ARROW -->
                            <v-col cols="1" class="arrowBox" v-if="active && activeStyle==='arrow'">
                                <v-btn icon>
                                    <v-icon size="100" color="primary">mdi-menu-right</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </v-container>

        <!-- MENU FOR ENABLING -->
        <v-menu
                v-model="menuModel"
                :close-on-content-click="false"
                :position-x="lastClickX"
                :position-y="lastClickY"
        >
            <v-card>

                <v-list>
                    <v-list-item>
                        <v-list-item-action>
                            <v-switch v-model="switchModel" color="primary"></v-switch>
                        </v-list-item-action>
                        <v-list-item-title>Enable locale</v-list-item-title>
                    </v-list-item>
                </v-list>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="menuModel = false">Cancel</v-btn>
                    <v-btn color="primary" text @click="saveClicked">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </v-card>
</template>

<script>

    export default {

        props: {
            data: {
                type: Object,
                required: true,
            },
            active: {
                type: Boolean,
                required: false,
                default: false,
            },
            activeStyle: {
                type: String,
                required: false,
                default: 'corner'
            },
            editable: {
                type: Boolean,
                required: false,
                default: true,
            },
            color: {
                type: String,
                required: false,
                default: 'grey darken-3'
            },
            highLightColor: {
                type: String,
                required: false,
                default: 'grey darken-1',
            },
            clickable: {
                type: Boolean,
                required: false,
                default: false,
            },
            toggleable: {
                type: Boolean,
                required: false,
                default: false,
            },
            width: {
                type: Number,
                required: false,
                default: null
            }
        },

        data() {
            return {
                menuModel: false,
                switchModel: false,
                lastClickX: 0,
                lastClickY: 0,
                boxColor: this.color,
                elevation: 1,
            }
        },

        computed: {
            locale() {
                return this.data;
            },
            activeClass() {
                let classes = ['ma-1'];
                if (this.editable || this.clickable) classes.push('cursor-pointer');
                if (this.active && this.activeStyle === 'corner') classes.push('indicator');
                return classes.join(' ');
            }
        },

        methods: {

            mouseover() {
                this.boxColor = this.highLightColor;
                this.elevation = 4;
            },

            mouseleave() {
                this.boxColor = this.color;
                this.elevation = 1;
            },

            localeClicked() {
                if (this.editable) {
                    this.switchModel = this.active;
                    this.lastClickX = event.clientX;
                    this.lastClickY = event.clientY;
                    this.menuModel = true;
                } else if (this.clickable) {
                    this.$emit('click', this.locale);
                } else if (this.toggleable) {
                    this.active ? this.$emit('disable', this.locale) : this.$emit('enable', this.locale);
                }
            },
            saveClicked() {
                this.enabled = this.switchModel;
                this.menuModel = false;
                this.emit();
            },
            emit() {
                if (this.switchModel) {
                    this.$emit('enable', this.locale);
                } else {
                    this.$emit('disable', this.locale);
                }
            }
        }
    }
</script>

<style scoped>

    .arrowBox {
        position: absolute;
        right: -10px;
        top: 35px;
        z-index: 1;
    }

    .indicator {
        position: relative;
    }

    .indicator::before,
    .indicator::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        border-color: transparent;
        border-style: solid;
    }

    .indicator::after {
        border-width: 1.35em;
        border-right-color: #43A047;
        border-top-color: #43A047;
    }
</style>
